import type { NSocialIntegrations } from '@app/services/rtkQuery/SocialIntegrations/types';

import type { WarehouseItem } from '@pages/Integrations/IntegrationsList/components/Add1CIntegrationModal/types';

export const normalizeWarehouses = (
  warehouses:
    | NSocialIntegrations.ModelIntegration1CWarehouse[]
    | null
    | undefined
): WarehouseItem[] => {
  if (!warehouses?.length) return [];

  return warehouses
    .map((warehouse) => {
      const guid1C = warehouse.Guid1C ?? '';
      const name = warehouse.WarehouseName ?? '';

      if (!guid1C || !name) return null;

      return {
        guid1C,
        name,
        isSelected: Boolean(warehouse.IsSeleted),
      };
    })
    .filter((item): item is WarehouseItem => Boolean(item));
};
